export default class ProfilePropertyModel {
  constructor(
    public UserID?: number,
    public PropertyDefinitionID?: number,
    public PropertyName?: string,
    public PropertyValue?: string,
    public LastUpdatedDate?: Date,
  ) {}
}
